import { FC } from 'react';
import { css } from '@emotion/react';
import { colors, spacing, fontStyles } from '../../styles';

type Theme = 'light' | 'dark' | 'auto';

interface Props {
  selectedTheme: Theme;
  onChange: (theme: Theme) => void;
}

const themes: { value: Theme; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'auto', label: 'Auto' },
];

const ThemeSelector: FC<Props> = ({ selectedTheme, onChange }) => {
  return (
    <div
      css={css`
        display: flex;
        flex: 1;
        gap: ${spacing.milli};
        padding: ${spacing.micro};
        background: ${colors.fog};
        border-radius: 12px;
        border: 0.5px solid ${colors.liquorice}20;

        html[data-theme='dark'] & {
          background: rgba(80, 78, 75, 0.3);
          border-color: ${colors.cloud}30;
        }
      `}
    >
      {themes.map((theme) => (
        <button
          key={theme.value}
          onClick={() => onChange(theme.value)}
          css={css`
            flex: 1;
            padding: ${spacing.centi} ${spacing.deci};
            border: none;
            border-radius: 10px;
            background: ${selectedTheme === theme.value ? 'white' : 'transparent'};
            color: ${selectedTheme === theme.value ? 'var(--text-color)' : colors.silver};
            box-shadow: ${selectedTheme === theme.value ? '0 1px 3px rgba(0, 0, 0, 0.08)' : 'none'};
            ${fontStyles.mouse};
            font-weight: ${selectedTheme === theme.value ? 500 : 400};
            cursor: pointer;
            transition: all 0.15s ease;

            &:hover {
              color: var(--text-color);
            }

            html[data-theme='dark'] & {
              background: ${selectedTheme === theme.value ? colors.liquorice : 'transparent'};
              color: ${selectedTheme === theme.value ? 'var(--text-color)' : colors.cloud};
            }
          `}
        >
          {theme.label}
        </button>
      ))}
    </div>
  );
};

export default ThemeSelector;
